import {FC, PropsWithChildren} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {useAuthStore} from 'stores';

const AppAuthFC: FC<PropsWithChildren> = ({children}) => {
  const {isAuthenticated} = useAuthStore(useShallow((state) => state));
  return <>{isAuthenticated ? children : null}</>;
};

export const AppAuth = AppAuthFC;
